import NavTabs, {
  NavTabPartialProps,
  TabItem,
} from "@/components/custom/tabs/nav-tabs";
import { useTranslation } from "react-i18next";
import { usePermissions } from "@/hooks/use-permissions";

export function useResourcesTabs(): TabItem[] {
  const { t } = useTranslation();
  const { permissions } = usePermissions();
  return [
    permissions.devices.view && {
      title: t("devices"),
      path: "devices",
      requiredPermissions: ["devices.view"],
      search: { __clear: true },
    },
    permissions.clusters.view && {
      title: t("clusters"),
      path: "clusters",
      requiredPermissions: ["clusters.view"],
      search: { __clear: true },
    },
    permissions.sites.view && {
      title: t("sites"),
      path: "sites",
      requiredPermissions: ["sites.view"],
      search: { __clear: true },
    },
    permissions.sites.view && {
      title: t("siteGroups"),
      path: "site-groups",
      requiredPermissions: ["sites.view"],
      search: { __clear: true },
    },
  ].filter(Boolean) as TabItem[];
}

export function ResourcesTabs({ children, ...props }: NavTabPartialProps) {
  const { t } = useTranslation();
  return (
    <NavTabs
      {...props}
      header={t("resources")}
      root={"/dashboard/resources"}
      items={useResourcesTabs()}
    >
      {children}
    </NavTabs>
  );
}
